var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useId } from 'react';
import { Box, Button, MessageBox, Modal, Trans, translate, useToastService, } from '@lucidlink/uicore';
import { ModalActions, ModalDescription, ModalTitle } from '#components';
import { useSetAccessSettings } from '../../../../../../query-hooks/mutations/useSetAccessSettings';
export const RestrictWebAccessModal = ({ closeModal, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const titleId = useId();
    const { addToast } = useToastService();
    const { mutation: { mutate: setAccessSettings }, } = useSetAccessSettings({ filespaceId, workspaceId }, {
        onSuccess: () => {
            addToast({
                'data-testid': 'success-filespace-restrict-web',
                kind: 'positive',
                content: {
                    message: translate('Web app access is now restricted.'),
                },
            });
            closeModal();
        },
        onError: () => {
            addToast({
                'data-testid': 'error-filespace-restrict-web',
                kind: 'negative',
                content: {
                    message: translate('Failed to restrict web app access'),
                    label: translate('Please try again.'),
                },
            });
        },
    });
    const restrictAccess = useCallback(() => {
        setAccessSettings({
            settingName: 'restrictWebAccess',
            settingValue: true,
        });
    }, [setAccessSettings]);
    return (_jsxs(Modal, { "aria-labelledby": titleId, closeModal: closeModal, "data-testid": "restrict-web", children: [_jsxs(Box, { gap: "s", orientation: "vertical", children: [_jsx(ModalTitle, { id: titleId, children: _jsx(Trans, { children: "Are you sure you want to restrict all access on the web app?" }) }), _jsxs(Box, { gap: "l", orientation: "vertical", children: [_jsx(ModalDescription, { children: _jsx(Trans, { children: "The filespace will be inaccessible on all web browsers. All users, including the workspace owner and admins, will be affected. This setting can be changed at any time from the desktop app." }) }), _jsx(MessageBox, { "data-testid": "restrict-web-access", type: "informative", children: _jsx(Trans, { children: "After this restriction is applied, all members must use version 3.1 or later to access this filespace from the desktop app." }) })] })] }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "restrict-web-access-cancel", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), _jsx(Button, { "data-testid": "restrict-web-access-confirm", isFullWidth: true, onClick: restrictAccess, size: "big", children: _jsx(Trans, { children: "Yes, restrict" }) })] })] }));
};
_react_refresh_temp_1 = RestrictWebAccessModal;
$RefreshReg$(_react_refresh_temp_1, "RestrictWebAccessModal");
_react_refresh_temp_2(RestrictWebAccessModal, "6MduEP9nA2p/omGguDf3pzYcQvQ=", false, () => [useToastService, useSetAccessSettings]);
